import { Chip, Stack } from '@mui/material'

import { ColumnPickerData } from '@/components/ColumnsPicker'

interface ChipListProps<T> {
	data: T[]
}

export const ChipList = <T extends ColumnPickerData>({
	data,
}: ChipListProps<T>) => {
	return (
		<Stack
			direction="row"
			spacing={1}
			flexWrap="wrap"
			useFlexGap
			sx={{ flexWrap: 'wrap' }}
		>
			{data.map(({ payload, rest }) => {
				return (
					<Chip
						key={payload?.uuid || rest?.code}
						label={rest?.name || rest?.code || payload?.code}
						disabled
					/>
				)
			})}
		</Stack>
	)
}
